import { render } from "./BookListCard.vue?vue&type=template&id=5b145111&scoped=true"
import script from "./BookListCard.vue?vue&type=script&lang=js"
export * from "./BookListCard.vue?vue&type=script&lang=js"

import "./BookListCard.vue?vue&type=style&index=0&id=5b145111&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b145111"]])

export default __exports__